/**
 * Portal Kit: ajudas puras dos editores (sem React, para o teste chamar direto).
 */
import type { ErroDeCampo } from '@/types/portal';

/** A primeira mensagem para exatamente este caminho (ou nulo). */
export function erroDe(erros: ErroDeCampo[], campo: string): string | null {
  return erros.find((e) => e.campo === campo)?.mensagem ?? null;
}

/** Cópia rasa de `obj` com `parcial` por cima (deixa os editores curtos). */
export function mesclar<T extends object>(obj: T, parcial: Partial<T>): T {
  return { ...obj, ...parcial };
}

/** Move o item de `de` para `para`, sem mutar a lista. Índice fora da lista não muda nada. */
export function mover<T>(lista: readonly T[], de: number, para: number): T[] {
  if (de < 0 || de >= lista.length || para < 0 || para >= lista.length || de === para) {
    return [...lista];
  }
  const copia = [...lista];
  const [item] = copia.splice(de, 1);
  copia.splice(para, 0, item);
  return copia;
}

/** Troca o item de índice `i` por `novo`. */
export function trocar<T>(lista: readonly T[], i: number, novo: T): T[] {
  return lista.map((x, k) => (k === i ? novo : x));
}

/** Remove o item de índice `i`. */
export function remover<T>(lista: readonly T[], i: number): T[] {
  return lista.filter((_, k) => k !== i);
}

/** Igualdade estrutural por JSON, suficiente para as configs (objetos simples). */
export function iguais(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

/** "{praca} ({sigla}) —" com os valores do formulário, como a matéria vai mostrar. */
export function exemploDeDateline(modelo: string, praca: string, sigla: string): string {
  return modelo.replaceAll('{praca}', praca).replaceAll('{sigla}', sigla);
}
